import React from 'react';
import { useTranslation } from 'react-i18next';
import CatalogManager from './CatalogManager';
import { Machinery } from '../../types/catalogs';

const MachineryPage: React.FC = () => {
  const { t } = useTranslation();
  const columns = [
    { key: 'codigo', label: t('code') },
    { key: 'tipo', label: t('typeLabel') },
    { key: 'descripcion', label: t('description') },
    { key: 'matricula', label: t('plate') },
  ];

  const formFields = [
    { name: 'codigo', label: t('code'), type: 'text' as const, required: true },
    {
      name: 'tipo',
      label: t('typeLabel'),
      type: 'select' as const,
      required: true,
      options: [
        { value: 'VEHICULO', label: t('typeVehicle') },
        { value: 'FRESADORA', label: t('typeMiller') },
        { value: 'EXTENDEDORA', label: t('typePaver') },
        { value: 'COMPACTADOR', label: t('typeCompactor') },
        { value: 'BARREDORA', label: t('typeSweeper') },
        { value: 'CAMION', label: t('typeTruck') },
        { value: 'OTRO', label: t('typeOther') },
      ],
    },
    { name: 'descripcion', label: t('description'), type: 'text' as const, required: true },
    { name: 'matricula', label: t('plate'), type: 'text' as const },
    { name: 'activo', label: t('active'), type: 'checkbox' as const },
  ];

  const createEmptyItem = () => ({
    codigo: '',
    tipo: '',
    descripcion: '',
    matricula: '',
    activo: true,
  });

  const validateItem = (item: any) => {
    if (!item.codigo?.trim()) return t('requiredCode');
    if (!item.tipo) return t('requiredType');
    if (!item.descripcion?.trim()) return t('requiredDescription');
    return null;
  };

  return (
    <CatalogManager<Machinery>
      title={t('catalogMachinery')}
      apiEndpoint="machineries"
      columns={columns}
      formFields={formFields}
      getItemId={(item) => item.id}
      getItemAttributes={(item) => item.attributes}
      createEmptyItem={createEmptyItem}
      validateItem={validateItem}
    />
  );
};

export default MachineryPage;
